import type { PageContext } from '@zto/zpage'

import { DialogType, EnableStatus } from '@/config'

export function addEditDialog(dialogType: DialogType) {
  const isAdd = dialogType === DialogType.ADD

  return {
    width: 920,
    labelWidth: 60,
    itemSpan: 12,

    onShow: ({ data }: PageContext) => {
      // data不能为空，否则textarea组件无法编辑
      let payload = { ...data, data: { ...data?.data } }

      if (isAdd) {
        payload = {
          parentNodeId: data.nodeId,
          parentNodePath: data.path,
          path: data.path + '/',
          status: EnableStatus.ENABLE,
          data: {}
        }
      }

      payload._dataStr = JSON.stringify(payload.data, null, 2)

      return { payload }
    },

    beforeSubmit: async ({ app, data }: PageContext) => {
      let _dataStr = (data._dataStr || '').trim()

      try {
        if (_dataStr) {
          data.data = JSON.parse(data._dataStr)
        }

        delete data._dataStr
      } catch (ex) {
        app.ui.showMessage('数据必须为JSON字符串')
        return
      }

      return data
    },

    formItems: [
      { label: '路径', type: 'text', span: 24, prop: 'path' },
      {
        label: '编号',
        type: !isAdd ? 'text' : 'input',
        prop: 'code',
        maxlength: 36,
        required: true,
        onChange: (data: any) => {
          data.path = data.parentNodePath + '/' + (data.code || '')
        }
      },
      { label: '名称', type: 'input', prop: 'name', maxlength: 50, required: true },
      { label: '序号', type: 'input-number', prop: 'sort', stepStrictly: true, required: true },
      {
        label: '状态',
        type: 'switch',
        prop: 'status',
        activeValue: EnableStatus.ENABLE,
        inactiveValue: EnableStatus.DISABLE,
        required: true
      },
      {
        label: '数据',
        type: 'textarea',
        prop: '_dataStr',
        span: 24,
        rows: 6,
        maxlength: 5000,
        autoHeight: true,
        rules: [
          {
            validator: (rule: any, val: any, cb: Function) => {
              try {
                JSON.parse(val)
                return cb()
              } catch (err) {
                return cb('请输入合法的JSON字符串')
              }
            },
            trigger: ['blur', 'change', 'input']
          }
        ]
      },
      // { label: false, type: 'sys-config-data-editor', prop: 'data', span: 24, autoHeight: true },
      { label: '备注', type: 'textarea', prop: 'remark', span: 24, autoHeight: true }
    ]
  }
}
